// ipop.js ポップアップウインドウ
//
// 使い方：
// <div id="ipop">
//   <div id="ipop_title">タイトル</div>
//   <div id="ipop_close">閉じるボタン</div>
//   中身
// </div>
//
// 上記のようなHTMLを作り、$.ipop() で呼び出す。

function ipop() {
	
	// ウインドウの座標を画面中央にする。高さは少し上目に設定
	var wx = $(document).scrollLeft() + ($(window).width() - $('#ipop').outerWidth()) / 2;
	if (wx < 0) wx = 0;
	var wy = $(document).scrollTop() + ($(window).height() - $('#ipop').outerHeight()) / 4;
	if (wy < 0) wy = 0;
	
	// ポップアップウインドウを表示する。
	$('#ipop').css({top: wy, left: wx}).fadeIn(100);
	
	// 閉じるボタンを押したとき
	$('#ipop_close').click(function() {$('#ipop').fadeOut(100);});
	
	// タイトルバーをドラッグしたとき
	$('#ipop_title').mousedown(function(e) {
		var mx = e.pageX;
		var my = e.pageY;
		$(document).on('mousemove.ipop', function(e) {
			wx += e.pageX - mx;
			wy += e.pageY - my;
			$('#ipop').css({top: wy, left: wx});
			mx = e.pageX;
			my = e.pageY;
			return false;
		}).one('mouseup', function(e) {
			$(document).off('mousemove.ipop');
		});
		return false;
	});

}
